// utils/tasks.js
import {privateApi} from '../utils/axios';

export const getEventTasks = async (eventId) => {
  const response = await privateApi.get(`/events/${eventId}/tasks`);
  return response.data;
};

export const getEventsTasks = async (eventIds) => {
  const response = await privateApi.get(`/events/multi-view/tasks?eventIds=${eventIds.join(',')}`);
  return response.data;
};

export const getTask = async (taskId) => {
  const response = await privateApi.get(`/tasks/${taskId}`);
  return response.data;
};

export const createTask = async (eventId, taskData) => {
  const response = await privateApi.post(`/events/${eventId}/tasks`, taskData);
  return response.data;
};

export const updateTask = async (taskId, taskData) => {
  const response = await privateApi.put(`/tasks/${taskId}`, taskData);
  return response.data;
};

export const deleteTask = async (taskId) => {
  const response = await privateApi.delete(`/tasks/${taskId}`);
  return response.data;
};
